"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GovernanceServiceClientState = exports.GovernanceServiceSurveyType = void 0;
/**
 * The enum is matching with Governance Service
 * So the missing number is not supported
 */
var GovernanceServiceSurveyType;
(function (GovernanceServiceSurveyType) {
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Unknown"] = 0] = "Unknown";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Feedback"] = 1] = "Feedback";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Nps"] = 2] = "Nps";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Psat"] = 4] = "Psat";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Bps"] = 6] = "Bps";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Fps"] = 8] = "Fps";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Nlqs"] = 18] = "Nlqs";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["GenericMessagingSurface"] = 22] = "GenericMessagingSurface";
  GovernanceServiceSurveyType[GovernanceServiceSurveyType["Intercept"] = 24] = "Intercept";
})(GovernanceServiceSurveyType = exports.GovernanceServiceSurveyType || (exports.GovernanceServiceSurveyType = {}));
var GovernanceServiceClientState;
(function (GovernanceServiceClientState) {
  GovernanceServiceClientState[GovernanceServiceClientState["Disabled"] = 0] = "Disabled";
  GovernanceServiceClientState[GovernanceServiceClientState["InitializationFailed"] = 1] = "InitializationFailed";
  GovernanceServiceClientState[GovernanceServiceClientState["Enabled"] = 2] = "Enabled";
})(GovernanceServiceClientState = exports.GovernanceServiceClientState || (exports.GovernanceServiceClientState = {}));